export const allowedTLDs = ["ru", "com", "org", "net", "by", "kz", "ua"];
export const nameRegex = /^[a-zA-Zа-яА-ЯёЁ\s-]{2,30}$/;
